import { isEmpty } from '@SonarCX/components/organisms/LexicalEditor'
import {
  ID_ATTR,
  parseAsHTML
} from '@SonarCX/components/organisms/LexicalEditor/helpers'
import { uploadFileArticle } from '@SonarCX/lib/api'

// Converts images with base64 sources to id
export const saveImages = async (text: string) => {
  if (isEmpty(text)) {
    return ''
  }
  const { root, images } = parseAsHTML(text)

  // Determine idx for image ordering
  let ids = []
  for (const img of images) {
    // Upload image and replace long data with id
    try {
      const res = await fetch(img.src)
      const blob = await res.blob()
      const mediaRes = await uploadFileArticle(blob)
      img.src = ''
      img.setAttribute(ID_ATTR, mediaRes?.id ?? '')
      ids.push(mediaRes?.id)
    } catch {
      img.src = ''
    }

    // Remove long src, since id exists
    if (img.hasAttribute(ID_ATTR)) {
      img.src = ''
    }
  }

  return { content: root.innerHTML, media_ids: ids }
}
